<template>
  <el-dialog
    :title="$t('app.debitTitle')"
    :visible.sync="dialogVisible"
    width="1000px"
    class="pre-new-stu-details"
  >
    <div style="height: 350px; overflow: auto">
      <el-radio-group v-model="debitType">
        <el-radio :label="false" style="color: red">免單</el-radio>
        <el-radio :label="true">開單</el-radio>
      </el-radio-group>
      <el-divider></el-divider>
      <el-form
        v-if="debitType == true"
        label-width="100px"
        label-position="top"
        size="small"
      >
        <el-col :span="12">
          <el-form-item :label="$t('app.internalRemark')">
            <el-input
              type="textarea"
              :rows="3"
              v-model="internalRemark"
              :disabled="false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('app.externalRemark')">
            <el-input
              type="textarea"
              :rows="3"
              v-model="externalRemark"
              :disabled="false"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('app.startDate')">
            <el-date-picker
              v-model="startDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('app.endDate')">
            <el-date-picker
              v-model="endDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('app.hostelDeadlineDate')">
            <el-date-picker
              v-model="hostelDeadlineDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              this.$t('app.defaultFee') +
                '(' +
                this.defaultFeeType +
                ')單位：分'
            "
          >
            <el-input
              type="text"
              :disabled="this.feeAuthorised"
              v-model="defaultFee"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="debit"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  newStudentDebit,
  getDebitConfig
} from "@/api/dormitoryManagement/preAllocNewStu";
import { oldStudentDebit } from "@/api/dormitoryManagement/preAllocOldStu";
import { validateModifyFeeAuth } from "@/api/systemManagement/roleManagement";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      payerIdGroup: [],
      internalRemark: "",
      externalRemark: "",
      startDate: "",
      endDate: "",
      hostelDeadlineDate: "",
      studentType: "",
      debitType: true,
      defaultFee: "",
      defaultFeeType: "",
      feeAuthorised: true
    };
  },
  created() {
    validateModifyFeeAuth().then(res => {
      this.feeAuthorised = !res.data;
    });
  },
  methods: {
    edit(payers, type, roomType, StudentCode) {
      this.payerIdGroup = [];
      // 如果没有学生应用ID，就用学生编号代替
      if (payers.length == 0) {
        payers = StudentCode;
      }
      if (payers.length == 0) {
        this.$message({
          message: "沒有需開單的學生",
          type: "info"
        });
        this.dialogVisible = false;
        return;
      }
      this.dialogVisible = true;
      if (typeof payers === "string") {
        this.payerIdGroup.push(payers);
      } else {
        this.payerIdGroup = payers;
      }
      this.studentType = type;
      console.log(this.debitType);
      this.getDebitConfig(roomType);
    },
    debitNewStudent() {
      newStudentDebit({
        PayerIdGroup: this.payerIdGroup,
        InternalRemark: this.internalRemark,
        ExternalRemark: this.externalRemark,
        StartDate: this.startDate,
        EndDate: this.endDate,
        HostelDeadlineDate: this.hostelDeadlineDate,
        IsDebit: this.debitType,
        DefaultFee: this.defaultFee,
        DefaultFeeType: this.defaultFeeType
      })
        .then(() => {
          this.success();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    debitOldStudent() {
      oldStudentDebit({
        PayerIdGroup: this.payerIdGroup,
        InternalRemark: this.internalRemark,
        ExternalRemark: this.externalRemark,
        StartDate: this.startDate,
        EndDate: this.endDate,
        HostelDeadlineDate: this.hostelDeadlineDate,
        IsDebit: this.debitType,
        DefaultFee: this.defaultFee,
        DefaultFeeType: this.defaultFeeType
      })
        .then(() => {
          this.success();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    debit() {
      this.$confirm(this.$t("app.debitConfirmDialog") + "?").then(() => {
        this.loading = true;
        if (this.studentType === "1") {
          this.debitNewStudent();
        } else if (this.studentType === "2") {
          this.debitOldStudent();
        }
      });
    },
    success() {
      this.$message({
        message: "開單成功",
        type: "success"
      });
      this.$emit("debitSuccess");
      this.dialogVisible = false;
    },
    getDebitConfig(roomType) {
      getDebitConfig({ RoomType: roomType }).then(res => {
        this.internalRemark = res.data.InternalRemark;
        this.externalRemark = res.data.ExternalRemark;
        this.startDate = res.data.StartDate;
        this.endDate = res.data.EndDate;
        this.hostelDeadlineDate = res.data.HostelDeadlineDate;
        this.defaultFee = res.data.DefaultFee;
        this.defaultFeeType = res.data.DefaultFeeType;
      });
    }
  }
};
</script>
<style lang="scss">
.pre-new-stu-details {
  .person-info,
  .application-form,
  .date-content {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
    }
  }
}
</style>
